import { Action } from 'redux';
import { PendoAccount, PendoVisitor } from '../@types';

export enum PendoActionType {
    RequestInitialize = 'requestInitializePendo'
}

export type PendoInitializeAction = Action<typeof PendoActionType.RequestInitialize> & {
    account: PendoAccount;
    visitor: PendoVisitor;
};

export type PendoAction = PendoInitializeAction;

export function requestInitializePendo(
	account: PendoAccount,
	visitor: PendoVisitor
): PendoInitializeAction {
	return {
		account,
		type: PendoActionType.RequestInitialize,
		visitor
	};
}
